/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import ReactDOM from 'react-dom/client';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';

import './assets/css/animate.min.css';
import './assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0';
import './assets/css/demo.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@grapecity/wijmo.styles/wijmo.css';
import '@grapecity/wijmo.cultures/wijmo.culture.ja';
import * as wjcCore from '@grapecity/wijmo';
wjcCore.setLicenseKey(process.env.REACT_APP_WIJIMO_LICENSE ?? '');

import { AuthContextProvider } from 'context/AuthContext';
import { AuthenticatedGuard } from 'context/AuthenticatedGuard';
import { RestApiContextProvider } from 'context/RestApiContext';
import { Login } from 'views/Login';
import { SharedClient } from 'views/SharedClient/SharedClient';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthContextProvider>
    <BrowserRouter>
      <RestApiContextProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/shared/*" element={<SharedClient />}></Route>
          <Route path="/*" element={<AuthenticatedGuard></AuthenticatedGuard>}></Route>
        </Routes>
      </RestApiContextProvider>
    </BrowserRouter>
  </AuthContextProvider>
);
